// eslint-disable-next-line filenames/match-regex
import {PortalTooltip, type PortalTooltipProps} from '@github-ui/portal-tooltip/portalled'
import {useCallback, useState} from 'react'

// TODO - this was copied from app/assets/modules/react-shared/hooks/use-alert-tooltip.tsx
// that file should be moved into it's own package and this file should be updated to use it
export function useAlertTooltip(
  id: string,
  contentRef: React.RefObject<HTMLElement>,
  portalTooltipProps?: Partial<PortalTooltipProps>,
): [(newMessage: string) => void, () => void, JSX.Element] {
  const [message, setMessage] = useState('')

  const clearMessage = useCallback(() => {
    setMessage('')
  }, [])

  const updateMessage = useCallback((newMessage: string) => {
    setMessage(newMessage)
  }, [])

  return [
    updateMessage,
    clearMessage,
    <AlertTooltip
      key={id}
      message={message}
      id={id}
      contentRef={contentRef}
      clearMessage={clearMessage}
      portalTooltipProps={portalTooltipProps}
    />,
  ]
}

function AlertTooltip({
  message,
  id,
  contentRef,
  clearMessage,
  portalTooltipProps,
}: {
  message: string
  id: string
  contentRef: React.RefObject<HTMLElement>
  clearMessage: () => void
  portalTooltipProps?: Partial<PortalTooltipProps>
}) {
  return message ? (
    <PortalTooltip
      id={id}
      contentRef={contentRef}
      aria-label={message}
      open={!!message}
      onMouseLeave={clearMessage}
      aria-live="assertive"
      {...portalTooltipProps}
    />
  ) : null
}

try{ AlertTooltip.displayName ||= 'AlertTooltip' } catch {}